import { CheckCircleIcon } from "@heroicons/react/solid";

import { cn } from "@/lib/utils";

interface SelectionIndicatorProps {
  isSelected: boolean;
  className?: string;
}

export const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({
  isSelected,
  className,
}) => {
  if (!isSelected) {
    return null;
  }

  return (
    <div className={cn("absolute right-2 top-2 z-10", className)}>
      <CheckCircleIcon className="h-6 w-6 rounded-full bg-white text-blue-600 shadow-sm" />
    </div>
  );
};
